import { Navigate } from 'react-router-dom';

/**
 * Legacy Settings → Publications path. Stage 19I folded publishing-destination
 * management into Settings › Integrations (Publer card) — redirect there.
 */
export function SettingsPublicationsScreen() {
  return <Navigate to="/settings/integrations" replace />;
}
